import * as React from "react"
import { Radio, RadioGroup } from "informed"
import * as s from "./style.scss"

interface IProps {
    periodItems: { value: number, description: string }[]
    initialPeriod: number
}


// Dynamic radio elements for the three time periods
export default ({ periodItems, initialPeriod }: IProps) => (
    <RadioGroup field="period" initialValue={initialPeriod}>
        <div className={s.navDayTimeBlock}>
            <ul className={s.navList}>
                {periodItems.map((value, index) => {
                    return (
                        <li className={s.radioTable} key={`times_${index}`}>
                            <Radio className={s.navRadio} id={`times_${index}`} value={value.value} />
                            <div className={s.radioLabelBox}>
                                <label htmlFor={`times_${index}`}>{value.description}</label>
                            </div>
                        </li>
                    )
                })}
            </ul>
        </div>
    </RadioGroup>
)